export const ORGANIZATIONS_RECORD_KEY = 'organizations';
export interface OrganizationType {
    name: string;
    id: string;
}
